/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';
import dayjs from 'dayjs';

import { PickerType } from '@totem/components/common/dateRangePicker/dateRangePickerExtended';

interface DateRangeContext {
  startDate: dayjs.Dayjs;
  startDateString: string;
  endDate: dayjs.Dayjs;
  endDateString: string;
  setRange: (start: dayjs.Dayjs, end: dayjs.Dayjs) => void;
  allowClear: boolean;
  defaultTimeFrame: PickerType;
}

export default createContext<DateRangeContext>({
  startDate: null,
  endDate: null,
  startDateString: '',
  endDateString: '',
  setRange: (start: dayjs.Dayjs, end: dayjs.Dayjs) => {},
  allowClear: true,
  defaultTimeFrame: 'week',
});
